import React from 'react';
import { ChevronDownIcon, MapPinIcon } from 'lucide-react';
import { IMAGES, LINKS } from '../data/site';
import { areaLinks } from '../data/navigation';
import { hours, locations, primaryServiceArea } from '../data/locations';
const serviceLinks = [{
  label: 'Auto Glass',
  href: LINKS.auto
}, {
  label: 'Windshield Replacement',
  href: LINKS.windshield
}, {
  label: 'Windshield Chip Repair',
  href: LINKS.chip
}, {
  label: 'ADAS Calibration',
  href: LINKS.adas
}, {
  label: 'Residential Glass',
  href: LINKS.residential
}, {
  label: 'Glass Shower Doors',
  href: LINKS.shower
}, {
  label: 'Commercial Glass',
  href: LINKS.commercial
}];
const supportLinks = [{
  label: 'Glass Resources & Guides',
  href: LINKS.resources
}, {
  label: 'Emergency Auto Glass',
  href: LINKS.emergencyAuto
}, {
  label: 'Contact Kosin’s Glass',
  href: LINKS.contact
}, {
  label: 'Locations & hours',
  href: '#locations'
}];
export function Footer() {
  const mainOffice = locations.find(office => office.isPrimary)!;
  const satelliteOffices = locations.filter(office => !office.isPrimary);
  return <footer className="w-full bg-kosin-charcoal" data-id="element-94" data-mp="3gapd7j63ckfz">
      <div className="mx-auto max-w-shell px-[18px] pb-6 pt-10 sm:px-6 lg:pt-12" data-id="element-95" data-mp="3gc0ixoj3k29q">
        <div className="grid grid-cols-1 gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-[1.05fr_0.85fr_2.1fr]" data-id="element-96" data-mp="3v8hr66vzp0s2">
          <div className="min-w-0" data-id="element-97" data-mp="3q726ifxq4wa7">
            <div className="inline-block rounded bg-white px-3 py-2" data-id="element-98" data-mp="830k9lv0mb22">
              <img src={IMAGES.logo} alt="Kosin’s Glass" width={227} height={95} className="h-[54px] w-auto" data-id="element-99" data-mp="817d85ghpotj" />
            </div>
            <p className="mt-4 max-w-[300px] text-[15px] leading-relaxed text-white/70" data-id="element-100" data-mp="hsttig7oqe35">
              Family-owned glass company serving Southeast Michigan since 2000.
            </p>
            <section aria-labelledby="footer-service-area-heading" className="mt-7" data-id="element-101" data-mp="cw33p162w44j">
              <h2 id="footer-service-area-heading" className="text-[15px] font-semibold text-white" data-id="element-102" data-mp="qtrok905bb9l">Service Area</h2>
              <p className="mt-2 text-[14px] leading-relaxed text-white/70" data-id="element-103" data-mp="mq3hrsjc8jpe">{primaryServiceArea}</p>
              <details className="group mt-1" data-id="element-104" data-mp="tta06hahyzxr">
                <summary className="focus-light flex min-h-11 cursor-pointer list-none items-center justify-between gap-3 text-[14px] font-medium text-white hover:text-kosin-ondark [&::-webkit-details-marker]:hidden" data-id="element-105" data-mp="yv92dnui3qt4">
                  More Service Areas
                  <ChevronDownIcon className="h-4 w-4 shrink-0 text-kosin-ondark transition-transform group-open:rotate-180" aria-hidden="true" data-id="element-106" data-mp="1clmcnwuv7hlm" />
                </summary>
                <nav aria-label="Service areas" data-id="element-107" data-mp="1hiul35q7o79o"><ul className="mt-1 grid grid-cols-2 gap-x-3 text-[13px] text-white/70" data-id="element-108" data-mp="1mjsaa29n21ko">{areaLinks.map(area => <li key={area.href} data-id="element-109" data-mp="1riv6cx7n4xgi"><a href={area.href} className="focus-light inline-flex min-h-11 items-center hover:text-white" data-id="element-110" data-mp="1rjepgh911rw4">{area.label}</a></li>)}</ul></nav>
              </details>
            </section>
          </div>

          <div className="grid min-w-0 grid-cols-2 content-start gap-x-5 gap-y-7 lg:grid-cols-1" data-id="element-111" data-mp="3t9q59xx59crg">
            {[{
            title: 'Services',
            label: 'Services',
            links: serviceLinks
          }, {
            title: 'Resources & Contact',
            label: 'Resources and contact',
            links: supportLinks
          }].map(group => <nav key={group.title} aria-label={group.label} data-id="element-112" data-mp="21nlclfa2unqj">
                <h2 className="text-[15px] font-semibold text-white" data-id="element-113" data-mp="1wnywmy2v6te1">{group.title}</h2>
                <ul className="mt-2 text-[14px] leading-5" data-id="element-114" data-mp="2tdziopbumvrn">
                  {group.links.map(link => <li key={link.label} data-id="element-115" data-mp="2pcntum0sueki">
                      <a href={link.href} className="focus-light inline-flex min-h-11 items-center py-1.5 text-white/70 transition-colors duration-150 ease-kosin hover:text-white lg:min-h-8" data-id="element-116" data-mp="2pcw5ybp3lfun">{link.label}</a>
                    </li>)}
                </ul>
              </nav>)}
          </div>

          <section id="locations" tabIndex={-1} aria-label="Locations and business hours" className="grid min-w-0 grid-cols-1 content-start gap-x-8 gap-y-9 sm:col-span-2 sm:grid-cols-[1.1fr_1fr] lg:col-span-1" data-id="element-117" data-mp="18w1n5dmw0dg3">
            <div className="min-w-0" data-id="element-118" data-mp="2rtwjpswmui7k">
              <section aria-labelledby="footer-howell-heading" data-id="element-119" data-mp="2wmpp8izxdukp">
                <h2 id="footer-howell-heading" className="text-[18px] font-semibold text-white" data-id="element-120" data-mp="2iv1funh29k7f">{mainOffice.city}</h2>
                <p className="mt-1 text-[13px] font-semibold leading-5 text-kosin-ondark" data-id="element-121" data-mp="2ntmgup4507wx">{mainOffice.role}</p>
                <address className="mt-3 text-[14px] not-italic leading-relaxed text-white/70" data-id="element-122" data-mp="3bjgrr14wbmej">
                  {mainOffice.address.map(line => <span key={line} className="block" data-id="element-123" data-mp="3fksaqnt9l9dr">{line}</span>)}
                </address>
                <a href={mainOffice.phoneHref} className="focus-light mt-1 inline-flex min-h-11 items-center text-[17px] font-semibold text-white transition-colors hover:text-kosin-ondark" data-id="element-124" data-mp="31krbtdwk8c0x">{mainOffice.phoneDisplay}</a>
                {mainOffice.directionsUrl && <a href={mainOffice.directionsUrl} className="focus-light flex min-h-11 items-center gap-1.5 text-[14px] text-white/70 underline underline-offset-4 hover:text-white" data-id="element-125" data-mp="1v604arcxlsxx">
                    <MapPinIcon className="h-4 w-4 shrink-0 text-kosin-ondark" aria-hidden="true" data-id="element-126" data-mp="1in4q9d2nxmbo" />
                    Get Directions To Howell
                  </a>}
              </section>
              <section aria-labelledby="footer-hours-heading" className="mt-7" data-id="element-127" data-mp="1rn19gz6a9szc">
                <h2 id="footer-hours-heading" className="text-[15px] font-semibold text-white" data-id="element-128" data-mp="13xyiv1to8psp">Business Hours</h2>
                <dl className="mt-2 max-w-[380px] text-[13px] leading-5" data-id="element-129" data-mp="zwn1tkov5cw4">
                  {hours.map(row => <div key={row.day} className="flex flex-wrap justify-between gap-x-3 gap-y-1 py-1.5" data-id="element-130" data-mp="1do1jno71b81l">
                      <dt className="text-white/70" data-id="element-131" data-mp="18w0cggoq47if">{row.day}</dt>
                      <dd className="m-0 whitespace-nowrap font-medium text-white" data-id="element-132" data-mp="l77d0a8w7hj2">{row.time}</dd>
                    </div>)}
                </dl>
              </section>
            </div>
            <section aria-labelledby="footer-satellite-heading" className="min-w-0" data-id="element-133" data-mp="2gawypqtrhw6h">
              <h2 id="footer-satellite-heading" className="text-[15px] font-semibold text-white" data-id="element-134" data-mp="2l9qexr0fo1ac">Satellite Offices</h2>
              <ul className="mt-4 space-y-7" data-id="element-135" data-mp="2pzx17k7h39pf">
                {satelliteOffices.map(office => <li key={office.city} className="min-w-0" data-id="element-136" data-mp="2v01jnfrxyeia">
                    <h3 className="text-[16px] font-semibold text-white" data-id="element-137" data-mp="2v1mbuyqs9lcz">{office.city}</h3>
                    <address className="mt-2 text-[14px] not-italic leading-relaxed text-white/70" data-id="element-138" data-mp="1xdm4wlqwfuyf">
                      {office.address.map(line => <span key={line} className="block" data-id="element-139" data-mp="27a77l0fg4tz3">{line}</span>)}
                    </address>
                    <a href={office.phoneHref} className="focus-light mt-1 inline-flex min-h-11 items-center text-[15px] font-semibold text-white transition-colors hover:text-kosin-ondark" data-id="element-140" data-mp="2bbanto1eos0u">{office.phoneDisplay}</a>
                  </li>)}
              </ul>
            </section>
          </section>
        </div>
        <div className="mt-9 flex flex-col justify-between gap-3 border-t border-white/10 pt-5 text-[13px] text-white/60 sm:flex-row sm:items-center" data-id="element-141" data-mp="1b3m3bjcw2v5q">
          <p data-id="element-142" data-mp="1744t6cmip9u8">© {new Date().getFullYear()} Kosin’s Glass. All rights reserved.</p>
          <nav aria-label="Legal and employment" className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-143" data-mp="1297ofhw9tmn5">
            <a href="/application-for-employment.html" className="focus-light inline-flex min-h-11 items-center hover:text-white" data-id="element-144" data-mp="xbftef0bxkeq">Employment</a>
            <a href="/terms-of-service.html" className="focus-light inline-flex min-h-11 items-center hover:text-white" data-id="element-145" data-mp="ne1ggpdm7dr6">Terms Of Service</a>
            <a href="/privacy-policy.html" className="focus-light inline-flex min-h-11 items-center hover:text-white" data-id="element-146" data-mp="jczg257yovnm">Privacy Policy</a>
          </nav>
        </div>
      </div>
    </footer>;
}